export default function setQffAuthenticationCookie(memberId?: string, token?: string) {
  if (memberId && token) {
    // set cookie
    document.cookie = `lsl_auth_data=${memberId}|${token};path=/`;
  } else {
    // delete cookie
    document.cookie = `lsl_auth_data=;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
  }
}
